// extracted by mini-css-extract-plugin
export var linkText = "_q9-0";